module.exports = __webpack_public_path__ + "static/media/fly0007.6e4d4098.webp";